<template>
  <table>
    <slot />
  </table>
</template>

<script>
export default {
  name: 'TableFi',
};
</script>
